import React from 'react';
import { Assistant } from '@/types';
import { AssistantCard, ComingSoonCard } from './';
import travelIcon from '@/assets/Travel Icon.svg';
import realEstateIcon from '@/assets/Real Estate Icon.svg';

interface AssistantGridProps {
    assistants: Record<string, Assistant>;
    onAssistantSelect: (assistantId: string) => void;
}

export const AssistantGrid: React.FC<AssistantGridProps> = ({
                                                                assistants,
                                                                onAssistantSelect
                                                            }) => {
    // Check if specific assistants exist in the backend data
    const hasHomesAssistant = Object.values(assistants).some(
        assistant => assistant.name === 'homesGPTforme' || assistant.id === 'homesGPTforme'
    );
    const hasTravelAssistant = Object.values(assistants).some(
        assistant => assistant.name === 'travelGPTforme' || assistant.id === 'travelGPTforme'
    );

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-5xl">
            {/* Active Assistants */}
            {Object.values(assistants).map(assistant => (
                <AssistantCard
                    key={assistant.id}
                    assistant={assistant}
                    onSelect={onAssistantSelect}
                />
            ))}

            {/* Coming Soon - HomesGPTforme (only show if not in backend) */}
            {!hasHomesAssistant && (
                <ComingSoonCard
                    name="homesGPTforme"
                    description="Your AI-powered real estate assistant for finding the perfect home"
                    icon={realEstateIcon}
                    iconAlt="Homes"
                    hoverColor="#A855f7"
                />
            )}

            {/* Coming Soon - TravelGPTforme (only show if not in backend) */}
            {!hasTravelAssistant && (
                <ComingSoonCard
                    name="travelGPTforme"
                    description="Your personal travel planner for unforgettable adventures worldwide"
                    icon={travelIcon}
                    iconAlt="Travel"
                    hoverColor="#c6f700"
                />
            )}
        </div>
    );
};